<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-15 19:10:38
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-29 11:58:02
-->
<template>
  <el-image class="ZImg" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: 'ZImg',
  data() {
    return {
      defaultImg: require('@/assets/images/no-goods.png')
    }
  }
}
</script>

<style scoped lang="scss">
.ZImg {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
</style>
